export const INITIAL = {
  VALUES: {
    number_installments: '',
  },
}
